import React from "react";
import { CountrySelectedContentProps } from "../utils/types";
import FlagIconCDN from "../../FlagIconCDN/FlagIconCDN";

const CountrySelectedContent: React.FC<CountrySelectedContentProps> = ({
  country,
}) => (
  <div className="flex items-center gap-[6px]">
    <FlagIconCDN
      code={country.flag}
      flagIconClassName="w-[18px] h-[14px] shrink-0"
    />
    <span className="text-md font-normal text-heading-text dark:text-heading-text-dk">
      {country.dialCode} {country.value}
    </span>
  </div>
);

export default CountrySelectedContent;
